export default __webpack_public_path__ + "static/media/arrow-icon.ceecbfa5.svg";